import type { ReactNode } from 'react';

/**
 * In-flow card notice for the onboarding funnel (ESCLOUD-286): what happened,
 * in plain words, and optionally what to do about it.
 *
 * Sits in the content column of `OnboardingShell`, where a full-page panel
 * would fight the shell's own header, stepper and sticky footer — the funnel
 * keeps its progress visible even when a step cannot proceed.
 */
export function NoticeCard({ title, body, action }: { title: string; body: ReactNode; action?: ReactNode }) {
    return (
        <div className="flex flex-col items-start gap-3 rounded-xl border border-border bg-card p-6">
            <p className="m-0 font-medium text-foreground">{title}</p>
            <div className="m-0 text-sm leading-relaxed text-muted-foreground">{body}</div>
            {action}
        </div>
    );
}
